import type TemporalUnit from "./TemporalUnit";
import dateTime from "./dateTime";

type Options = { timeZone?: string; locale?: string };

export default function endOf(
  date: Date,
  unit: TemporalUnit,
  options: Options = {},
) {
  return dateTime(date, options).endOf(unit).toJSDate();
}
